module.exports = __webpack_public_path__ + "media/images/favicon-0b6dfdf1f6f9ce48dff4857cddca4894.ico";